import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function FinalCTASection() {
  const handleBuyClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Método Depto-Dog',
        content_type: 'product',
        value: 8999,
        currency: 'ARS'
      });
    }
    window.location.href = 'https://amigospeludosarg.shop/cart/49017965412594:1';
  };
  return <section id="comprar" className="py-14 sm:py-24 px-5 sm:px-8 bg-depto-brown text-center relative overflow-hidden" data-id="element-57">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/hvuyirXv5zFBxTTt89bjXG/DEPTO-DOG_Mockup_1x1.png')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-58"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-59">
        <FadeIn data-id="element-60">
          <h2 className="text-4xl sm:text-5xl text-depto-cream mb-8 leading-tight" data-id="element-61">
            LLEVATE EL MÉTODO DEPTO-DOG HOY
          </h2>
          <p className="text-xl text-depto-cream/80 mb-12 leading-relaxed" data-id="element-62">
            Dejá de vivir con el nudo en la garganta cada vez que salís de tu
            casa. Dale a tu perro la calma que necesita y recuperá tu
            tranquilidad.
          </p>

          <div className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/10 mb-10 inline-block" data-id="element-63">
            <p className="text-sm font-sans font-bold tracking-widest text-depto-amber uppercase mb-2" data-id="element-64">
              PRECIO LANZAMIENTO
            </p>
            <p className="text-5xl font-serif text-white" data-id="element-65">$8.999 ARS</p>
          </div>

          <div className="flex flex-col items-center" data-id="element-66">
            <Button className="mb-6 text-xl py-5 px-10 w-full sm:w-auto" onClick={handleBuyClick} data-id="element-67">
              QUIERO EL MÉTODO AHORA
            </Button>

            <div className="flex items-center gap-2 text-depto-cream/60 text-sm font-medium" data-id="element-68">
              <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-69" />
              <span data-id="element-70">Compra segura. Descarga inmediata en formato PDF.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}